<template>
  <div>
    <b-tabs>
      <b-tab>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>{{ $t('Wasl Information') }}</span>
        </template>

        <b-form class="repeater-form" style="overflow: visible;">
          <!-- sequenceNumber -->
          <b-row class="mt-3">
            <b-col cols="12">

              <b-form-group :label="$t('Sequence Number')">
                <b-input-group class="input-group-merge">
                  <b-form-input v-model="deviceData.sequenceNumber" :state="null" :placeholder="$t('sequenceNumber')"
                    :disabled="$store.state.device.data.wasl" />
                </b-input-group>
                <small v-if="errors && ('sequenceNumber' in errors)" class="text-danger">
                  {{ $t(errors['sequenceNumber'][0]) }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="6">

              <b-form-group :label="$t('Refrance Key')">
                <b-input-group class="input-group-merge">
                  <b-form-input v-model="deviceData.referenceKey" :disabled="!isRefranceKeyUpdate" :state="null"
                    :placeholder="$t('referenceKey')" />
                </b-input-group>
                <small v-if="errors && ('referenceKey' in errors)" class="text-danger">
                  {{ $t(errors['referenceKey'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col class="mt-3" cols="3">
              <div id="tooltip-target-wasl">
                <b-form-checkbox v-model="isRefranceKeyUpdate" :value="true"> {{ $t('Update Via RefranceKey') }}
                </b-form-checkbox>
              </div>
              <b-tooltip target="tooltip-target-wasl" triggers="hover">
                <b> {{ $t('Enable Update Via RefranceKey') }}</b>
              </b-tooltip>
            </b-col>
          </b-row>



          <!-- plateType -->
          <b-row>
            <b-col cols="12">
              <b-form-group :label="$t('Plate Type')">
                <v-select v-model="deviceData.plateType" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :getOptionLabel="type => type ? type[$i18n.locale] : ''" :options="plateTypesOptions"
                  :reduce="type => type.code" :disabled="$store.state.device.data.wasl" />
                <small v-if="errors && ('plateType' in errors)" class="text-danger">
                  {{ $t(errors['plateType'][0]) }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- imeiNumber -->
          <b-row>
            <b-col cols="12">
              <b-form-group :label="$t('IMIE Number')">
                <b-input-group class="input-group-merge">
                  <b-form-input v-model="deviceData.imeiNumber" :state="null" :placeholder="$t('imeiNumber')" />
                </b-input-group>
                <small v-if="errors && ('imeiNumber' in errors)" class="text-danger">
                  {{ $t(errors['imeiNumber'][0]) }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mt-1 mb-4" cols="3">
              <div id="tooltip-target-wasl-live-location">

                <b-form-checkbox 
                  v-model="deviceData.wasl_enabled"> {{ $t('Enable Send Live Location') }}
                </b-form-checkbox>
              </div>
              <!-- <b-tooltip target="tooltip-target-wasl-live-location" placement="bottom" :show="true"
                :variant="getIsQualfiedSendLiveLocation() == true ? 'success' : 'danger'" triggers="hover">
                <b> {{ $t('driver Registered WithWasl :') }} <feather-icon
                    :icon="getIcon($store.state.device.data.waslIntegrationStatus.driverRegisteredWithWasl)"
                    class="mr-25" /></b><br />
                <b> {{ $t('has Scale Sensors Setting :') }}<feather-icon
                    :icon="getIcon($store.state.device.data.waslIntegrationStatus.hasScaleSensorsSetting)"
                    class="mr-25" /></b><br />
                <b> {{ $t('has Weight :') }}<feather-icon
                    :icon="getIcon($store.state.device.data.waslIntegrationStatus.hasWeight)" class="mr-25" /></b><br />
                <b> {{ $t('registered With Wasl :') }}<feather-icon
                    :icon="getIcon($store.state.device.data.waslIntegrationStatus.registeredWithWasl)"
                    class="mr-25" /></b><br />
              </b-tooltip> -->
            </b-col>

          </b-row>

          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" @click="saveWaslInof('save')"
            variant="primary" class="mr-1">
            {{ $t($store.state.device.data.wasl ? 'update' : 'register') }}
          </b-button>


          <b-button v-if="$store.state.device.data.wasl" v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button"
            @click="deleteWasl()" variant="danger" class="mr-1">
            {{ $t('Delete') }}
          </b-button>

        </b-form>
      </b-tab>
      <b-tab v-if="$store.state.device.data.wasl" @click="saveWaslInof('getInfo')">
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>{{ $t('Wasl Status') }}</span>
        </template>

        <!-- {{ waslStatusData }} -->
        <div class="mt-5" v-if="Object.keys(waslStatusData).length !== 0">

          <app-timeline>

            <app-timeline-item :title="$t('company')" :subtitle="waslStatusData.company.toString()" icon="InfoIcon"
              variant="success" />
            <app-timeline-item :title="$t('plate')"
              :subtitle="waslStatusData.plate.number + ' -  ' + waslStatusData.plate.leftLetter + ' ' + waslStatusData.plate.middleLetter + ' ' + waslStatusData.plate.rightLetter"
              icon="InfoIcon" variant="success" />
            <app-timeline-item :title="$t('Is Vehicle Valid')" :subtitle="waslStatusData.isVehicleValid.toString()"
              icon="InfoIcon" variant="success" />
            <app-timeline-item :title="$t('Vehicle Rejection Reason')" :subtitle="waslStatusData.vehicleRejectionReason"
              icon="InfoIcon" variant="success" />
            <app-timeline-item :title="$t('Registration Time')" :subtitle="waslStatusData.registrationTime"
              icon="ClockIcon" variant="success" />
            <app-timeline-item :title="$t('latleng')" subtitle="waslStatusData.vehicleLocationInformation.latitude"
              icon="MapPinIcon" variant="success">
              <h4 class="custom-timeline">{{ $t('Location') }}</h4>
              <a :href="'https://www.google.com/maps/?q=' + waslStatusData.vehicleLocationInformation.latitude + ',' + waslStatusData.vehicleLocationInformation.longitude"
                target="_blank"> {{
                  waslStatusData.vehicleLocationInformation.latitude
                    + "," + waslStatusData.vehicleLocationInformation.longitude
                }}</a>
            </app-timeline-item>
            <app-timeline-item :title="$t('Status')" :subtitle="waslStatusData.vehicleLocationInformation.vehicleStatus"
              icon="InfoIcon" variant="success" />
            <app-timeline-item :title="$t('Actual Time')"
              :subtitle="waslStatusData.vehicleLocationInformation.actualTime" icon="ClockIcon" variant="primary" />
            <app-timeline-item :title="$t('Received Time')"
              :subtitle="waslStatusData.vehicleLocationInformation.receivedTime" icon="ClockIcon" variant="success" />
          </app-timeline>
        </div>
      </b-tab>
    </b-tabs>




  </div>

</template>

<script>

import {
  BButton, BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BForm, BTabs, BTab, BCardText, BFormCheckbox, VBTooltip, BTooltip
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref, onMounted, on, onUnmounted, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { stat } from 'fs'




export default {
  props: {
    deviceData: {
      type: Object,
      required: true
    },

  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BForm,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    vSelect,
    OrbitSpinner, BTabs, BTab, BCardText, BFormCheckbox, VBTooltip, BTooltip,
    AppTimeline,
    AppTimelineItem,
  },

  setup(props, { root }) {
    const getIcon = (status) => {
      return status == true ? 'CheckIcon' : 'XIcon'
    }



    const getIsQualfiedSendLiveLocation = () => {
      return (store.state.device.data.waslIntegrationStatus.driverRegisteredWithWasl == true &&
        store.state.device.data.waslIntegrationStatus.hasScaleSensorsSetting == true &&
        store.state.device.data.waslIntegrationStatus.hasWeight == true &&
        store.state.device.data.waslIntegrationStatus.registeredWithWasl == true
      )
    }

    const isRefranceKeyUpdate = ref(false)
    const waslSendLiveLocation = ref(false)
    if (props.deviceData.waslSendLiveLocation == true) {
      waslSendLiveLocation.value = true;
    }

    const s = store.state.device
    const errors = computed(() => s.errors)
    let type = "vehicleRegistration";
    const waslStatusData = ref({})


    const deleteWasl = id => {

      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("Do you want to delete vehicle from wasl?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          saveWaslInof('delete')


        }
      })
    }




    const saveWaslInof = (actionType) => {

      const { plate_right, plate_left, plate_middle, plate_number, wasl } = props.deviceData
      let type = "";
      if (wasl == true) { type = "vehicleUpdate" }

      if (wasl == false) { type = "vehicleRegistration" }
      if (actionType == "delete") { type = "vehicleDelete" }
      if (actionType == "getInfo") { type = "vehicleInquiry" }
      const waslRegisterRequest = ref({
        "type": type,

        "device_id": store.state.device.data.device_id,

        "vehiclePlate": {
          "number": plate_number,
          "rightLetter": plate_right,
          "middleLetter": plate_middle,
          "leftLetter": plate_left
        },
        "sequenceNumber": props.deviceData.sequenceNumber,
        "plateType": props.deviceData.plateType,
        "imeiNumber": props.deviceData.imeiNumber,
        "activity": "DEFAULT",
        "waslSendLiveLocation": props.deviceData.waslSendLiveLocation,


      });

      const franceKeyUpdateRequest = ref({
        type: 'vehicleSetReferenceKey',
        device_id: store.state.device.data.device_id,
        referenceKey: props.deviceData.referenceKey,


      })





      if (type == "vehicleUpdate") {
        if (isRefranceKeyUpdate.value == true) {
          disPatchWaslData(franceKeyUpdateRequest.value)
        }

        if (isRefranceKeyUpdate.value == false) {
          disPatchWaslData(waslRegisterRequest.value)
        }

      } else if (type == "vehicleRegistration" && isRefranceKeyUpdate.value == false) {

        disPatchWaslData(waslRegisterRequest.value)
      } else if (type == "vehicleRegistration" && isRefranceKeyUpdate.value == true) {

        disPatchWaslData(franceKeyUpdateRequest.value)
      } else if (type == "vehicleDelete") {
        disPatchWaslData(waslRegisterRequest.value)
      }

    }

    const disPatchWaslData = (request) => {
      store.dispatch('device/saveWaslData', request).then(res => {
        if (request.type == "vehicleDelete") { waslSendLiveLocation.value = false; isRefranceKeyUpdate.value = false; }
        //refetch device data
        store.dispatch('device/fetchDeviceData', store.state.device.data.id)
        if (request.type !== "vehicleInquiry") {
          root.$bvToast.toast(
            root.$i18n.t("sucess"), {
            title: `Success`,
            variant: 'success',
          })
        } else {

          waslStatusData.value = res
        }
      }).catch(reason => {

        if (reason.status == 400) {

          root.$bvToast.toast(
            root.$i18n.t("Error Code:" + reason.data.errorCode + " - errorMsg " + reason.data.errorMsg), {
            title: `Danger`,
            variant: 'danger',
          })
        }
        if (reason.status == 422) {

          let errorMessage = "Error on save wsal data"

          if (reason.data.errors != undefined && reason.data.errors.errorMsg != undefined) {
            errorMessage = reason.data.errors.errorMsg;
          }
          if (reason.data.errors != undefined && reason.data.errors.resultMsg != undefined) {
            errorMessage = reason.data.errors.resultMsg;
          }
          root.$bvToast.toast(
            root.$i18n.t(errorMessage), {
            title: `Error`,
            variant: 'danger',
          })
        }


      })

    }
    const plateTypesOptions = [
      { code: 1, en: "Private Car", ar: "خصوصي" },
      { code: 2, en: "Public Transport", ar: "نقل عام" },
      { code: 3, en: "Private Transport", ar: "نقل خاص" },
      { code: 4, en: "Public Bus", ar: "حافلة صغيرة عامة" },
      { code: 5, en: "Private Bus", ar: "حافلة صغيرة خاصة" },
      { code: 6, en: "Taxi", ar: "اجرة" },
      { code: 7, en: "Heavy Equipment", ar: "معدات ثقيلة" },
      { code: 8, en: "Export", ar: "تصدير" },
      { code: 9, en: "Diplomatic", ar: "دبلوماسي" },
      { code: 10, en: "Motorcycle", ar: "دراجة نارية" },
      { code: 11, en: "Temporary", ar: "مؤقت" },
    ]

    return {
      saveWaslInof,
      waslSendLiveLocation,
      plateTypesOptions,
      errors,
      deleteWasl,
      getIcon,
      waslStatusData, isRefranceKeyUpdate, getIsQualfiedSendLiveLocation

    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.custom-timeline,
.d-flex.flex-sm-row.flex-column.flex-wrap.justify-content-between.mb-1.mb-sm-0 h6 {
  font-size: 19px;
  font-style: oblique;
  font-weight: bold;
}
</style>
